import { Link } from "react-router-dom";
import { company, contact, nav, services } from "@/config/content";
import { Logo } from "@/components/site/Logo";
import { scrollToId } from "@/lib/nav";

export const Footer = () => (
  <footer className="bg-charcoal text-white/80" data-testid="site-footer">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid gap-10 md:grid-cols-2 lg:grid-cols-4">
      <div>
        <Logo dark />
        <p className="mt-4 text-sm leading-relaxed text-white/60 max-w-xs">
          Ihr Gebäudeservice für Reinigung, Objektpflege sowie Trockenbau- und Innenausbauarbeiten
          in Bremen und Umgebung.
        </p>
        <p className="mt-4 text-xs text-white/40 max-w-xs">{company.brandLine}</p>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4">Navigation</h3>
        <ul className="space-y-2.5">
          {nav.map((n) => (
            <li key={n.href}>
              <button onClick={() => scrollToId(n.href)} className="text-sm text-white/60 hover:text-white transition-colors">{n.label}</button>
            </li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4">Leistungen</h3>
        <ul className="space-y-2.5">
          {services.map((s) => (
            <li key={s.id} className="text-sm text-white/60">{s.title}</li>
          ))}
        </ul>
      </div>

      <div>
        <h3 className="font-heading font-bold text-white text-sm uppercase tracking-wider mb-4">Kontakt</h3>
        <ul className="space-y-2.5 text-sm text-white/60">
          <li>Bremen &amp; Umgebung</li>
          <li>Tel.: <a href={contact.phoneHref} className="hover:text-white transition-colors">{contact.phone}</a></li>
          <li>E-Mail: <a href={`mailto:${contact.email}`} className="hover:text-white transition-colors break-all">{contact.email}</a></li>
          <li>{contact.address}</li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
        <p className="text-sm text-white/50">© {new Date().getFullYear()} {company.legalName}</p>
        <div className="flex items-center gap-6 text-sm">
          <Link to="/impressum" data-testid="footer-impressum" className="text-white/60 hover:text-white transition-colors">Impressum</Link>
          <Link to="/datenschutz" data-testid="footer-datenschutz" className="text-white/60 hover:text-white transition-colors">Datenschutzerklärung</Link>
        </div>
      </div>
    </div>
  </footer>
);
